export default __webpack_public_path__ + "static/media/gold-10.269723fb.png";